import Icon from "@bokio/designsystem/components/Icon/Icon";
import { Link } from "@bokio/elements/Link/Link";
import { LottieAnimation } from "@bokio/elements/LottieAnimation/LottieAnimation";
import Markdown from "@bokio/elements/Markdown/Markdown";
import { mergeClassNames } from "@bokio/utils/classes";

import type { FC } from "react";

import * as styles from "./ratingToast.scss";

interface CompleteStepProps {
	description: string;
	title: string;
	onClose: () => void;
}

export const CompleteStep: FC<CompleteStepProps> = ({ description, title, onClose }) => {
	return (
		<article>
			<header className={styles.completeStepHeader}>
				<Link onClick={onClose} className={styles.closeButton}>
					<Icon name="cancel" />
				</Link>
			</header>
			<section className={styles.complete}>
				<LottieAnimation
					animation={import("@bokio/companies/src/assets/lottieAnimations/checkmark")}
					height="144px"
					testId={"Rating_Complete"}
				/>
				<span className={mergeClassNames(styles.title, styles.completeTitle)}>{title}</span>
				<Markdown
					deprecatedNativeHtmlElementClassName={mergeClassNames(styles.description, styles.completeDescription)}
					markdownContent={description}
					deprecatedOptoutFromTypographicElements
				/>
			</section>
		</article>
	);
};
